<div class="card card-block page-card">
  <div class="d-flex justify-content-between">
    <h3 class="app-page-title">Customers ({{tableFilteredData.length}})</h3>
    <!-- <div class="btn-group ml-3" btnRadioGroup ngDefaultControl [(ngModel)]="environment.environment" >
      <label [ngClass]="getEnvButtonClass('test')" btnRadio="test" tabindex="0" role="button">Test</label>
      <label [ngClass]="getEnvButtonClass('production')" btnRadio="production" tabindex="0" role="button">Production</label>
  </div> -->
    <environment-switcher (environmentChanged)="onEnvironmentChanged($event)"></environment-switcher>
  </div>
  <br/>
  <form class="form-inline">
    <ng-select
      [items]="groupsFilterData | async"
      [searchable]="true"
      [multiple]="true"
      [closeOnSelect]="false"
      [groupBy]="groupsFilterGroupByFn"
      [selectableGroup]="true"
      [selectableGroupAsModel]="false"
      bindLabel="Name"
      placeholder="Filter by AU groups"
      [(ngModel)]="selectedGroups"
      (change)="onGroupsFilterChange()"
      name="groupsFilter"
    ></ng-select>
  </form>
  <br/>
  <ng-table
    id="customersTable" 
    [config]="config" 
    (cellClicked)="onCellClick($event)" 
    [columns]="columns"
    [showResetFiltersButton]=true
    [data]="filteredData"
    (tableChanged)="onTableChanged($event)"
    (filtersReseted)="onTableFiltersReseted($event)"
    ></ng-table>
  <hr/>
  <form class="form-inline">
    <button type="button" class="btn btn-light mr-2" (click)="ngOnInit()">Refresh</button>
    <button type="button" class="btn btn-light" (click)="onExport()">Export</button>
    <div class="mr-auto"></div>
    <button type="button" class="btn btn-light mr-2" (click)="onBlock()">Block</button>
    <button type="button" class="btn btn-light" (click)="onUnblock()">Unblock</button>
  </form>
</div>